import { render, staticRenderFns } from "./iconHeadphone.vue?vue&type=template&id=453e22f3"
import script from "./iconHeadphone.vue?vue&type=script&lang=js"
export * from "./iconHeadphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports